export const COFFEE_LINK = 'https://ko-fi.com/juliencalixte'
export const BRAVE_LINK = 'https://brave.com/vaq785'
